

export const operators = [
  {id: 3, name: "Zain"},
  {id: 4, name: "STC"},
  {id: 2, name: "Mobily"},
  {id: 9, name: "ZainFgc"},
  {id: 5, name: "OmanTel"},
  {id: 8, name: "Oreddoo"},
]

export const monthNames = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};
